import create from "zustand";

interface PropertyListModalState {
  isOpen: boolean;
}

interface PropertyListModalActions {
  onOpen: () => void;
  onClose: () => void;
}

const usePropertyListModal = create<PropertyListModalState & PropertyListModalActions>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default usePropertyListModal;
